import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  OnInit,
  signal
} from '@angular/core'
import { SafeHtml } from '@angular/platform-browser'

@Component({
    selector: 'app-info-box',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './info-box.component.html',
    styleUrl: './info-box.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoBoxComponent implements OnInit {
  title = input.required<string>()
  content = input.required<SafeHtml>()
  type = input.required<'info' | 'warning' | 'error' | 'success'>()

  collapsed = signal<boolean>(true)

  private storageKey = computed(
    () => `info-box:${this.title().replace(/\s+/g, '-').toLowerCase()}`
  )

  private readonly ariaRoleMapBasedOnType: Record<
    'info' | 'warning' | 'error' | 'success',
    'status' | 'alert'
  > = {
    info: 'status',
    success: 'status',
    warning: 'alert',
    error: 'alert'
  }

  readonly ariaRole = computed(() => this.ariaRoleMapBasedOnType[this.type()])

  constructor() {
    effect(() => {
      localStorage.setItem(this.storageKey(), String(this.collapsed()))
    })
  }

  ngOnInit() {
    const stored = localStorage.getItem(this.storageKey())
    if (stored !== null) this.collapsed.set(stored === 'true')
  }

  toggleCollapse() {
    this.collapsed.update((isCollapsed) => !isCollapsed)
  }
}
